import { FC, MouseEvent, useEffect, useState } from 'react';
import appLinks from '../../constants/app-links';
import { BUTTON_VARIANTS } from '../../constants/button-variants';
import AppLogo from '../../images/app-logo.jpg';
import translation from '../../languages';
import analytics from '../../services/analytics';
import qualityEvents from '../../services/quality-events';
import isPrerender from '../../utils/is-prerender';
import os from '../../utils/os';
import Button from '../button/button';
import './smart-banner.scss';

const SmartAppBanner: FC<TranslationProps> = ({ t }) => {
    const [src, setSrc] = useState('');
    const [closed, setClosed] = useState(() => window.storage.getItem('appBanner') === 'closed');

    const text = os?.isIOS ? 'App Store' : 'Google Play';
    const tags = 'utm_source=website&utm_medium=banner&utm_campaign=AppBannerOnMobile&utm_content=banner1';
    const link = os?.isIOS ? `${appLinks.IOS}?${tags}` : `${appLinks.Android}&${tags}`;

    useEffect(() => {
        if (isPrerender()) {
            return;
        }

        const imageLoader = new Image();

        imageLoader.src = AppLogo;

        imageLoader.onload = () => {
            setSrc(AppLogo);
        };
    }, []);

    const closeBanner = (event: MouseEvent<HTMLElement>) => {
        event.preventDefault();
        setClosed(true);
        window.storage.setItem('appBanner', 'closed');
    };

    const handleBannerClick = () => {
        analytics.push({
            event: 'gtmEvent',
            eventAction: 'DownloadAppButtonClicked',
            eventCategory: 'mkt-userInteraction',
            eventNonInteraction: false
        });
        qualityEvents.track({
            type: 'DownloadAppButtonClicked'
        });
        window.location.replace(
            `${link}?utm_source=website&utm_medium=banner&utm_campaign=AppBannerOnMobile&utm_content=banner1`
        );
    };

    if ((!os?.isAndroid && !os?.isIOS) || closed) {
        return null;
    }

    return (
        <div className='smartbanner d-flex' id='smartbanner'>
            <div className='smartbanner-container d-flex align-items-center justify-content-between'>
                <span className='smartbanner-icon' style={{ backgroundImage: src ? `url(${src})` : '' }} />
                <div className='smartbanner-info'>
                    <div className='smartbanner-title'>{t('common.appBanner.app')}</div>
                    <span>
                        {t('common.appBanner.free')} &ndash; {text}
                    </span>
                </div>
                <div className='align-self-stretch'>
                    <a className='smartbanner-close' href='#' id='smb-close' onClick={closeBanner}>
                        &times;
                    </a>
                    <a className='d-block mt-2' onClick={handleBannerClick}>
                        <Button className='smartbanner-button' variant={BUTTON_VARIANTS.SMALL}>
                            {t('common.appBanner.download')}
                        </Button>
                    </a>
                </div>
            </div>
        </div>
    );
};

const translate = translation('common');

export default translate(SmartAppBanner);
